import { MessageTypeEnumValue } from 'enums/MessageTypeEnum';
import { SHOW_MESSAGE } from 'redux/Message/MessageType';

export default function reportError(error, dispatch, resetAction) {
  if (dispatch) {
    if (resetAction)
      dispatch({
        type: resetAction,
      });

    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MessageTypeEnumValue.Danger,
        titleKey: 'error',
        messageKey:
          error.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.messages?.[0] || 'error',
      },
    });
  }

  return Promise.reject(error.response);
}
